import Collapse from '@mui/material/Collapse';
import Fade from '@mui/material/Fade';
import { signupCopy } from '@/Pages/Signup/copy';
import { SignupFormField } from '@/Pages/Signup/components/SignupFormField';
import { applyCpfMask } from '@/Pages/Signup/utils/cpfMask';
import '@/Pages/Signup/SignupPage.sass';

const BRAZIL_NATIONALITY = 'BR';

type SignupDocumentFieldProps = {
  nationality: string;
  value: string;
  error?: string;
  showError: boolean;
  onChange: (value: string) => void;
  onBlur: () => void;
};

export function SignupDocumentField({
  nationality,
  value,
  error,
  showError,
  onChange,
  onBlur,
}: SignupDocumentFieldProps): JSX.Element {
  const isBrazil = nationality === BRAZIL_NATIONALITY;
  const fieldKey = isBrazil ? 'cpf' : 'document';

  const handleChange = (nextValue: string) => {
    onChange(isBrazil ? applyCpfMask(nextValue) : nextValue);
  };

  return (
    <Collapse in className="signup-document-field" data-testid="signup-document-field">
      <Fade in key={fieldKey} timeout={280}>
        <div className="signup-document-field__inner">
          <SignupFormField
            id="document"
            label={isBrazil ? signupCopy.cpfLabel : signupCopy.documentLabel}
            value={value}
            placeholder={
              isBrazil ? signupCopy.cpfPlaceholder : signupCopy.documentPlaceholder
            }
            error={error}
            showError={showError}
            onChange={handleChange}
            onBlur={onBlur}
            inputMode={isBrazil ? 'numeric' : 'text'}
            autoComplete="off"
          />
        </div>
      </Fade>
    </Collapse>
  );
}
